import * as React from "react";

import RouteLoadSpinner from "../route-load-spinner.tsx";

import EmbeddedPageTemplate from "./embedded-page-template.tsx";

type Props = Record<any, any>;

/**
 * Spinner component to display while a route is loading.
 *
 * This should only be used directly in embedded routes (e.g. in an iframe on
 * a page). For non-embedded routes, use the RouteLoadSpinner component instead.
 */
const EmbeddedRouteLoadSpinner = (props: Props): React.ReactElement => (
    <RouteLoadSpinner template={EmbeddedPageTemplate} {...props} />
);

export default EmbeddedRouteLoadSpinner;
